<template>
  <label :class="'touchpoint touchpoint--' + (labelClassName)" :for="`${itemName}${moduleKey}`">
    <input
      type="radio"
      :id="`${itemName}${moduleKey}`"
      :value="(itemId || itemName)"
      :class="'touchpoint__input ' + (inputStyle)"
      :name="`${collectionName}${moduleKey}`"
      @change="updateValue($event)"
      v-validate="validationRules"
      :data-vv-scope="validationScope"
      :checked="isSelected"/>
    <i :class="['touchpoint__icon touchpoint__icon--' + (collectionClassName || itemClassName), hideImage ? 'touchpoint__icon--no-image' : '']">
      <span :class="'touchpoint__name ' + (radioButtonTextClass) + ' touchpoint__name--checked'">
        {{itemText}}
      </span>
    </i>
  </label>
</template>

<script lang="ts">
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import {
  Component,
  Prop,
  Vue,
  Inject,
  Watch
} from 'vue-property-decorator';
import { stringHelperService } from '@/services/StringHelperService';

@Component
export default class FormTouchPointComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public itemName!: string;

  @Prop({ default: null })
  public collectionName!: string;

  @Prop({ default: null })
  public collectionClassName!: string;

  @Prop({ default: false })
  public selected!: boolean;

  @Prop({ default: null })
  public radioId!: string;

  @Prop({ default: null })
  public itemText!: string;

  @Prop({ default: null })
  public radioButtonTextClass!: string;

  @Prop({ default: null })
  public itemId!: string;

  @Prop({ default: null })
  public inputStyle!: string;

  @Prop({ default: null })
  public labelClassName!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'required' })
  public validationRules!: string;

  @Prop({ default: 0 })
  public arrayLength!: number;

  @Prop({ default: '' })
  public moduleKey!: string;

  @Prop({ default: false })
  public hideImage!: boolean;

  private isSelected: boolean = false;

  get itemClassName(): string {
    if (this.collectionName === 'fuelType') {
      return stringHelperService.classifyFuelType(this.itemName);
    }
    return stringHelperService.classifyString(this.itemName);
  }

  @Watch('arrayLength')
  public checkArrayLength() {
    this.preSelectItem();
  }

  public updateValue(e: any) {
    this.$emit(this.collectionName, e.target.value);
  }

  public preSelectItem() {
    if (this.selected) {
      this.isSelected = true;
    } else {
      this.isSelected = this.selected;
    }
    this.$validator.validateAll(this.validationScope);
  }

  public created() {
    this.preSelectItem();
  }
}
</script>
